var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#252153"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2144 18.6226L28.9161 11H27.3282L21.5066 17.6172L16.8602 11H11.5L18.5277 21.0072L11.5 29H13.0879L19.2319 22.0104L24.1398 29H29.5L22.2144 18.6226ZM20.0389 21.0951L19.3258 20.098L13.6605 12.1713H16.0997L20.6732 18.5708L21.3833 19.5679L27.3275 27.8858H24.8882L20.0389 21.0951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhiteIcon);
export default __webpack_public_path__ + "static/media/twitter-white-icon.fd8525d55a42d5e79c58fc93030119ae.svg";
export { ForwardRef as ReactComponent };